import React, { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

export const FitnessKidDiscountCard = ({ formData, setFormData, discountData }) => {
    const [dropDown, setDropDown] = useState(false);
    const [dropDown2, setDropDown2] = useState(false);
    const [appointments, setAppointments] = useState("2");
    const [entries, setEntries] = useState(8);
    const [payment, setPayment] = useState(30);
    const [time, setTime] = useState("18:00");
    const [saturdayTime, setSaturdayTime] = useState("Select Time Slot");
    const [dropDownSaturday, setDropDownSaturday] = useState(false);
    const [plan, setPlan] = useState(false);
    const [timeSlots, setTimeSlots] = useState([]);
    const { t } = useTranslation();

    // Define constant mapping between displayed (translated) days and database days
    const DAY_MAPPING = {
        [t('monday')]: 'MONDAY',
        [t('tuesday')]: 'TUESDAY',
        [t('wednesday')]: 'WEDNESDAY',
        [t('thursday')]: 'THURSDAY',
        [t('friday')]: 'FRIDAY',
        [t('saturday')]: 'SATURDAY'
    };

    // Reverse mapping for display purposes
    const REVERSE_DAY_MAPPING = Object.entries(DAY_MAPPING).reduce((acc, [key, value]) => {
        acc[value] = key;
        return acc;
    }, {});

    const handleDayClick = (displayDay) => {
        const dbDay = DAY_MAPPING[displayDay];
        const isSaturday = dbDay === 'SATURDAY';
        const slotTime = isSaturday ? '08:00' : time;
    
        if (timeSlots.some(slot => slot.day === dbDay)) {
            setTimeSlots(timeSlots.filter(slot => slot.day !== dbDay));
        } else if (timeSlots.length < Number(appointments)) {
            setTimeSlots([...timeSlots, { day: dbDay, time: slotTime }]);
        }
    };

    const handleSaturdayTimeClick = (selectedTime) => {
        const dbDay = 'SATURDAY';
        const saturdaySlotIndex = timeSlots.findIndex(slot => slot.day === dbDay);
    
        if (saturdaySlotIndex !== -1) {
            const updatedTimeSlots = [...timeSlots];
            updatedTimeSlots[saturdaySlotIndex].time = selectedTime;
            setTimeSlots(updatedTimeSlots);
        } else if (timeSlots.length < Number(appointments)) {
            setTimeSlots([...timeSlots, { day: dbDay, time: selectedTime }]);
        }
    };

    const handleChosePlan = () => {
        if (timeSlots.length < Number(appointments)) {
            toast.warning(`Please select ${appointments} days`);
            return;
        }
        
        setFormData((prevData) => ({
            ...prevData,
            days: timeSlots,
            time: 1,
            timings: time,
            entries: entries,
            totalAmount: payment,
            payableAmount: payment
        }));
    };

    const getPrice = () => {
        switch(appointments) {
            case "2":
                return "30 €";
            case "3":
                return "40 €";
            default:
                return "20 €";
        }
    };

    return (
        <div className="flex flex-col gap-5 border-2 border-gray-200 rounded-2xl min-w-[320px] p-6 max-h-fit h-fit font-custom2 bg-white shadow-lg hover:shadow-xl transition-shadow duration-300">
            {/* Appointments per week dropdown */}
            <div className="flex flex-col gap-2 rounded-xl relative w-full">
                <button
                    onClick={() => setDropDown(!dropDown)}
                    id="dropdownDefaultButton"
                    data-dropdown-toggle="dropdown"
                    className="text-blue-700 bg-blue-50 border border-blue-200 font-semibold rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center justify-between w-full hover:bg-blue-100 transition-colors"
                    type="button"
                >
                    {appointments}x {t('Week')}
                    <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                    </svg>
                </button>

                <div id="dropdown" className={`z-10 bg-white text-black top-12 absolute divide-y divide-gray-100 rounded-lg shadow-lg border border-gray-200 w-full ${dropDown ? 'block' : 'hidden'}`}>
                    <ul className="py-2 text-sm" aria-labelledby="dropdownDefaultButton">
                        {[
                            { value: "1", entries: 4, payment: 20 },
                            { value: "2", entries: 8, payment: 30 },
                            { value: "3", entries: 12, payment: 40 }
                        ].map((option) => (
                            <li key={option.value}>
                                <a
                                    href="#"
                                    className="block px-4 py-2.5 hover:bg-blue-50 hover:text-blue-700 transition-colors cursor-pointer"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setAppointments(option.value);
                                        setDropDown(false);
                                        setEntries(option.entries);
                                        setPayment(option.payment);
                                        setTimeSlots([]);
                                    }}
                                >
                                    {option.value}x {t('Week')}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Time selection */}
            <div className="flex flex-col gap-2 rounded-xl relative w-full">
                <button
                    onClick={() => setDropDown2(!dropDown2)}
                    id="dropdownTimeButton"
                    data-dropdown-toggle="dropdownTime"
                    className="text-blue-700 bg-blue-50 border border-blue-200 font-semibold rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center justify-between w-full hover:bg-blue-100 transition-colors"
                    type="button"
                >
                    {t('time')}: {time}
                    <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                    </svg>
                </button>

                <div id="dropdownTime" className={`z-10 bg-white text-black top-12 absolute divide-y divide-gray-100 rounded-lg shadow-lg border border-gray-200 w-full ${dropDown2 ? 'block' : 'hidden'}`}>
                    <ul className="py-2 text-sm" aria-labelledby="dropdownTimeButton">
                        {["18:00", "19:00"].map((timeOption) => (
                            <li key={timeOption}>
                                <a
                                    href="#"
                                    className="block px-4 py-2.5 hover:bg-blue-50 hover:text-blue-700 transition-colors cursor-pointer"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setTime(timeOption);
                                        setDropDown2(false);
                                    }}
                                >
                                    {timeOption} - {parseInt(timeOption) + 1}:00
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Schedule selection */}
            <div className="flex flex-col gap-1">
                <div className="p-1 px-3 text-blue-700">
                    {t('schedule')}
                    <div className="p-4 w-full rounded-xl bg-blue-50 border border-blue-200 text-blue-700">
                        {/* First row of days */}
                        <div className="grid grid-cols-3 gap-2">
                            {[t('monday'), t('tuesday'), t('wednesday')].map(displayDay => (
                                <div
                                    key={displayDay}
                                    className={`border-[1px] rounded border-blue-700 px-2 cursor-pointer text-center ${
                                        timeSlots.some(slot => slot.day === DAY_MAPPING[displayDay])
                                            ? 'bg-blue-700 text-white rounded bg-opacity-75'
                                            : ''
                                    }`}
                                    onClick={() => handleDayClick(displayDay)}
                                >
                                    {displayDay}
                                </div>
                            ))}
                        </div>
                        {/* Second row of days */}
                        <div className="grid grid-cols-3 gap-2 mt-2">
                            {[t('thursday'), t('friday'), t('saturday')].map(displayDay => (
                                <div
                                    key={displayDay}
                                    className={`border-[1px] rounded border-blue-700 px-2 cursor-pointer text-center ${
                                        timeSlots.some(slot => slot.day === DAY_MAPPING[displayDay])
                                            ? 'bg-blue-700 text-white rounded bg-opacity-75'
                                            : ''
                                    }`}
                                    onClick={() => handleDayClick(displayDay)}
                                >
                                    {displayDay}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Saturday time selection */}
                {timeSlots.some(slot => slot.day === 'SATURDAY') && (
                    <div className="flex flex-col gap-2 rounded-2xl relative w-[200px] mt-2">
                        <button
                            onClick={() => setDropDownSaturday(!dropDownSaturday)}
                            id="dropdownSaturdayButton"
                            data-dropdown-toggle="dropdownSaturday"
                            className="text-blue-700 bg-blue-50 border border-blue-200 font-semibold rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center justify-between w-full hover:bg-blue-100 transition-colors"
                            type="button"
                        >
                            {saturdayTime}
                            <svg className="w-2.5 h-2.5 ms-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 4 4 4-4" />
                            </svg>
                        </button>

                        <div id="dropdownSaturday" className={`z-10 bg-white text-black top-12 absolute divide-y divide-gray-100 rounded-lg shadow-lg border border-gray-200 w-full ${dropDownSaturday ? 'block' : 'hidden'}`}>
                            <ul className="py-2 text-sm" aria-labelledby="dropdownSaturdayButton">
                                {[
                                    { time: "09:00", display: "09:00 - 10:00" },
                                    { time: "10:00", display: "10:00 - 11:00" }
                                ].map((option) => (
                                    <li key={option.time}>
                                        <a
                                            href="#"
                                            className="block px-4 py-2.5 hover:bg-blue-50 hover:text-blue-700 transition-colors cursor-pointer"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleSaturdayTimeClick(option.time);
                                                setDropDownSaturday(false);
                                                setSaturdayTime(option.time);
                                            }}
                                        >
                                            {option.display}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}

                <div className="flex flex-col gap-4 pt-2">
                    <div className="flex items-center gap-2">
                        <span className="text-gray-600 font-medium">{t('choose')} {appointments} {t('days_of_week')}</span>
                    </div>
                    <div className="flex flex-col gap-2 bg-gray-50 rounded-lg p-4 border border-gray-200">
                        <div className="flex items-center justify-between">
                            <span className="text-gray-700 font-semibold">Çmimi</span>
                            <span className="text-black-600 font-bold text-2xl">{getPrice()}</span>
                        </div>
                    </div>
                    <button
                        onClick={() => {
                            setPlan(!plan);
                            handleChosePlan();
                        }}
                        className={`w-full border-2 font-bold rounded-xl py-3 px-4 transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-[1.02] ${
                            plan 
                                ? 'bg-blue-600 border-blue-600 text-white' 
                                : 'bg-white border-blue-600 text-blue-600 hover:bg-blue-50'
                        }`}
                    >
                        {plan ? t('unChoosePlan') : t('choosePlan')}
                    </button>
                </div>
            </div>
        </div>
    );
};